
    import './styles.scoped.css';
    export default {
  "arrow": "_arrow_7leje_3",
  "arrow-outer": "_arrow-outer_7leje_7",
  "arrow-inner": "_arrow-inner_7leje_7",
  "arrow-position-right-top": "_arrow-position-right-top_7leje_38",
  "arrow-position-right-bottom": "_arrow-position-right-bottom_7leje_38",
  "arrow-position-left-top": "_arrow-position-left-top_7leje_41",
  "arrow-position-left-bottom": "_arrow-position-left-bottom_7leje_41",
  "arrow-position-top-center": "_arrow-position-top-center_7leje_44",
  "arrow-position-top-responsive": "_arrow-position-top-responsive_7leje_44",
  "arrow-position-bottom-center": "_arrow-position-bottom-center_7leje_47",
  "arrow-position-bottom-responsive": "_arrow-position-bottom-responsive_7leje_47",
  "root": "_root_7leje_51",
  "layout-wrapper": "_layout-wrapper_7leje_52",
  "close-button": "_close-button_7leje_57",
  "layout": "_layout_7leje_52",
  "layout-no-scroll": "_layout-no-scroll_7leje_70",
  "layout-main": "_layout-main_7leje_74",
  "layout-main-scrollable": "_layout-main-scrollable_7leje_79",
  "drawer": "_drawer_7leje_83",
  "drawer-mobile": "_drawer-mobile_7leje_89",
  "drawer-closed": "_drawer-closed_7leje_92",
  "drawer-content": "_drawer-content_7leje_100",
  "toggle": "_toggle_7leje_122",
  "breadcrumbs-desktop": "_breadcrumbs-desktop_7leje_127",
  "content-wrapper": "_content-wrapper_7leje_131",
  "content-wrapper-mobile": "_content-wrapper-mobile_7leje_134",
  "notifications-sticky": "_notifications-sticky_7leje_142",
  "announcement-popover-target": "_announcement-popover-target_7leje_148",
  "navigation": "_navigation_7leje_154",
  "navigation-toggle": "_navigation-toggle_7leje_158",
  "navigation-close": "_navigation-close_7leje_162",
  "tools": "_tools_7leje_166",
  "tools-toggle": "_tools-toggle_7leje_170",
  "tools-close": "_tools-close_7leje_174",
  "notifications": "_notifications_7leje_142",
  "breadcrumbs": "_breadcrumbs_7leje_127",
  "content": "_content_7leje_131"
};
  